import React, {useEffect} from 'react';
import AssetField from '../../../contentful/AssetField';
import FileAssetField from '../../../contentful/FileAssetField';
import update from 'immutability-helper';
import cookie from 'js-cookie';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import ReactJson from 'react-json-view';
import {func, bool, shape, string} from 'prop-types';
import EntityCollectionField from '../../../contentful/EntityCollectionField';


const propTypes = {
  onSave: func.isRequired,
  onPublish: func.isRequired,
  onChange: func.isRequired,
  onArchive: func.isRequired,
  onUnArchive: func.isRequired,
  equipment: shape({}),
  model: shape({}),
  working: bool,
  modified: bool,
  error: string
};

const defaultProps = {
  equipment: {},
  model: {},
  working: false,
  modified: false,
  error: ''
};

const EquipmentComponent = (props) => {
  const {
    onSave,
    onPublish,
    onUnpublish,
    onChange,
    onArchive,
    onUnArchive,
    equipment,
    model,
    working,
    modified,
    error,
    setError,
    linkedEntries
  } = props;

  useEffect(() => {
    const tab = cookie.get('mgEquipmentTab');
    if (tab !== '' && tab !== undefined && document.getElementById(tab)) {
      const tabLink = document.getElementById(tab);
      tabLink.click();
    }
  }, []);

  /* Handle submit */
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  const handlePublish = (e) => {
    e.preventDefault();
    onPublish();
  };

  const handleUnpublish = (e) => {
    e.preventDefault();
    onUnpublish();
  };

  const handleAssetChange = (name, asset) => {
    const change = {
      equipment: {}
    };

    change.equipment[name] = {
      $set: asset
    };

    const updatedProps = update(props, change);

    onChange(updatedProps);
  };

  const handleFieldChange = (e) => {
    return handleAssetChange(e.target.name, e.target.value);
  };

  const setTabCookie = (e) => {
    const tabLink = e.target.id;
    const cookieName = 'mgEquipmentTab';

    cookie.set(cookieName, tabLink, {path: '/'});
  };

  const handleIncludedEquipmentChange = (name, asset) => {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    // Check if the included equipment is a package or not. We currently
    // do not support packages in packages so we will have to block it here.
    const assetItem = asset[asset.length - 1] ?? null;
    if (assetItem) {
      if (assetItem.includedEquipment.length > 0) {
        setError('Systemet tillater ikke pakker i pakker. Vennligst velg et annet utstyr, eller fjern alt utstyr fra pakken du prøvde å legge til');
        throw new Error('Systemet tillater ikke pakker i pakker. Vennligst velg et annet utstyr, eller fjern alt utstyr fra pakken du prøvde å legge til');
      }
    }

    handleFieldChange(event);
  };

  const priceValue = `${equipment.price},-`;
  const predefinedTags = [model.make.name, model.name, 'Tilbehør'];

  // IDs excluded from the search, so that it is not possible to add itself, or items already in the package.
  const excludedIDs = [equipment.id, ...equipment.includedEquipment.map((item) => item.id)];

  return (
    <section className="mf-equipment-equipment">
      <ol className="breadcrumb mf-margin-top-20">
        <li><Link to="/">Forsiden</Link></li>
        <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
        <li>
          <Link to={`/modeller/${model.make.id}`}>{model.make.name}</Link>
        </li>
        <li>
          <Link to={`/modeller/${model.make.id}/modell/${model.id}`}>{model.name}</Link>
        </li>
        <li className="active">{equipment.nameCustom || equipment.name}</li>
      </ol>

      <form onSubmit={handleSubmit}>
        <div className="page-header">
          <div className="row">
            <div className="col-xs-12 col-sm-8">
              <h1>
                {equipment.nameCustom || equipment.name} <PublishStatusDot entry={equipment} /><br/>
                <small>Tilbehør</small>
              </h1>
            </div>

            <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
              {working &&
                <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
              }
              {!equipment.archived &&
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!modified || working}
                >
                  <span>Lagre endringer</span>
                </button>
              }
              &nbsp;
              <button
                type="button"
                className="btn btn-success"
                disabled={!(equipment.draft || equipment.updated) || equipment.archived || working || modified}
                onClick={handlePublish}
              >
                <span>Publiser</span>
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning"
                disabled={equipment.draft || working || modified}
                onClick={handleUnpublish}
              >
                <span>Avpubliser</span>
              </button>
              &nbsp;
              {!equipment.archived &&
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={(working)}
                  onClick={(e) => {
                    e.preventDefault();
                    onArchive();
                  }}
                >
                  <span>Arkiver</span>
                </button>
              }
              {equipment.archived &&
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={(working)}
                  onClick={(e) => {
                    e.preventDefault();
                    onUnArchive();
                  }}
                >
                  <span>Gjenopprett</span>
                </button>
              }
            </div>
          </div>
        </div>

        {/* Display any error message: */}
        {error &&
          <div className="alert alert-danger">
            {error}
          </div>
        }

        <ul className="nav nav-tabs" role="tablist">
          <li role="presentation" className="active"><a href="#general" id="generalTab" data-target="#general" aria-controls="general" role="tab" data-toggle="tab" onClick={setTabCookie}>Generelt</a></li>
          <li role="presentation"><a href="#contents" id="contentsTab" data-target="#contents" aria-controls="contents" role="tab" data-toggle="tab" onClick={setTabCookie}>Innhold</a></li>
        </ul>

        {/* Tab content */}
        <div className="tab-content mf-margin-bottom-40">
          {/* General tab */}
          <div role="tabpanel" className="tab-pane active" id="general">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Navn <small>{equipment.custom ? '' : '(Valgfri)'}</small></label>
                  <input type="text" className="form-control" disabled={working || equipment.archived} name="nameCustom" placeholder={equipment.name} defaultValue={equipment.nameCustom} onChange={handleFieldChange} />
                  {!equipment.custom &&
                      <span className="help-block">Om utfylt vil denne teksten overstyre navn fra WebCapri.</span>
                  }
                </div>
                <div className="form-group">
                  <label>Beskrivelse <small>{equipment.custom ? '' : '(Valgfri)'}</small></label>
                  <textarea className="form-control" name="descriptionCustom" disabled={working || equipment.archived} rows="10" placeholder={equipment.description} defaultValue={equipment.descriptionCustom} onChange={handleFieldChange}></textarea>
                  {!equipment.custom &&
                      <span className="help-block">Om utfylt vil denne teksten overstyre beskrivelsen fra WebCapri.</span>
                  }
                </div>
                <div className="form-group">
                  <label>MVA kalkulering</label>
                  {equipment.validVatOptions &&
                      <select
                        type="text"
                        className="form-control"
                        name="vatOption"
                        defaultValue={equipment.vatOption}
                        disabled={working || equipment.archived}
                        onChange={handleFieldChange}
                      >
                        <option value="">-- Velg utregning --</option>
                        {equipment.validVatOptions.map((group, key) => {
                          return <option key={key} value={group.value}>{group.name}</option>;
                        })}
                      </select>
                  }
                </div>
                <div className="form-group">
                  <label>Tag <small>(Valgfri)</small></label>
                  <input type="text" disabled={working || equipment.archived} className="form-control" name="tag" placeholder="F.eks Populær eller Anbefalt" defaultValue={equipment.tag} onChange={handleFieldChange} />
                </div>
                <div className="form-group">
                  <label>Bilde</label>
                  <AssetField
                    name="image"
                    value={equipment.image}
                    onChange={handleAssetChange}
                    disabled={working || equipment.archived}
                    predefinedTags={predefinedTags}
                  />
                </div>
                <div className="form-group">
                  <label>Informasjonsfil (PDF)</label>
                  <FileAssetField
                    name="informationFile"
                    value={equipment.informationFile}
                    onChange={handleAssetChange}
                    disabled={working || equipment.archived}
                    predefinedTags={predefinedTags}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                {!equipment.custom &&
                    <div className="form-group">
                      <label>Navn</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="name" defaultValue={equipment.name} disabled/>
                        <div className="input-group-addon">Data fra WebCapri</div>
                      </div>
                    </div>
                }
                <div className="form-group">
                  <label>Varenr</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="eqId" defaultValue={equipment.eqId} disabled={!equipment.custom || (working || equipment.archived)} onChange={handleFieldChange}/>
                    <div className="input-group-addon">{equipment.custom ? '' : 'Data fra WebCapri'}</div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Kode</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="code" defaultValue={equipment.code} disabled={!equipment.custom || (working || equipment.archived)} onChange={handleFieldChange}/>
                    <div className="input-group-addon">{equipment.custom ? '' : 'Data fra WebCapri'}</div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Kategori</label>
                  <div className="input-group">
                    <select
                      type="text"
                      className="form-control"
                      name="category"
                      defaultValue={equipment.category}
                      disabled={!equipment.custom || (working || equipment.archived)}
                      onChange={handleFieldChange}
                    >
                      <option value="">-- Velg kategori --</option>
                      <option value="Anbefalt tilbehør">Anbefalt tilbehør</option>
                      <option value="Innvendig">Innvendig</option>
                      <option value="Utvendig">Utvendig</option>
                      <option value="Dekk">Dekk</option>
                    </select>
                    <div className="input-group-addon">{equipment.custom ? '' : 'Data fra WebCapri'}</div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Prioritet</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="priority" defaultValue={equipment.priority} disabled={!equipment.custom || (working || equipment.archived)} onChange={handleFieldChange}/>
                    <div className="input-group-addon">{equipment.custom ? '' : 'Data fra WebCapri'}</div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Pris <small>(Uten mva)</small></label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="price" defaultValue={equipment.custom ? equipment.price : priceValue} disabled={!equipment.custom || (working || equipment.archived)} onChange={handleFieldChange}/>
                    <div className="input-group-addon">{equipment.custom ? '' : 'Data fra WebCapri'}</div>
                  </div>
                </div>
                {!equipment.custom && <div>
                  <div className="form-group">
                    <label>Original beskrivelse <small>(Data fra WebCapri)</small></label>
                    <textarea className="form-control" name="description" rows="10" defaultValue={equipment.description} disabled></textarea>
                  </div>
                  <div className="form-group">
                    <label>Prisgrunnlag <small>(Data fra WebCapri)</small></label>
                    <ReactJson
                      name={false}
                      src={equipment.prices}
                      displayObjectSize={false}
                      displayDataTypes={false}
                      enableClipboard={false}
                    />
                  </div>
                </div>}
              </div>
            </div>
          </div>

          {/* Contents tab */}
          <div role="tabpanel" className="tab-pane" id="contents">
            {linkedEntries.length > 0 && (
              <div className="alert alert-warning">
                Kan ikke gjøre om utstyr til pakke siden utstyret ligger i en annen pakke allerede:
                <ul>
                  {linkedEntries.map((entry) => (
                    <li key={entry.sys.id}>
                      <a href={`/${entry.sys.contentType.sys.id}/${entry.sys.id}`}>{entry.fields.name['nb-NO']}</a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {linkedEntries.length === 0 && (
              <div className="row">
                <div className="col-xs-12 col-md-12">
                  <label>Inkludert tilbehør</label>
                  <EntityCollectionField
                    name="includedEquipment"
                    value={equipment.includedEquipment}
                    contentType="equipment"
                    quickAdd={true}
                    searchParams={{
                      'fields.model.sys.id': model.id,
                      'fields.group[ne]': true,
                      'fields.includedEquipment[exists]': false,
                      'sys.id[nin]': excludedIDs.join(',')
                    }}
                    searchOnOpen={true}
                    onChange={handleIncludedEquipmentChange}
                    disabled={working || equipment.archived }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

EquipmentComponent.propTypes = propTypes;
EquipmentComponent.defaultProps = defaultProps;

export default EquipmentComponent;
